export default "__VITE_ASSET__BLyvPCxL__"